import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Mail, MessageSquare, MapPin, Phone } from 'lucide-react';

const Contact = () => {
  const contacts = [
    { icon: Mail, title: '邮箱联系', desc: 'contact@cattravellog.com', detail: '工作日24小时内回复' },
    { icon: MessageSquare, title: '在线客服', desc: '微信客服: cattravellog', detail: '9:00-22:00在线服务' },
    { icon: Phone, title: '客服热线', desc: '400-888-8888', detail: '周一至周日9:00-21:00' },
    { icon: MapPin, title: '公司地址', desc: '北京市朝阳区xx路xx号', detail: '欢迎预约参观' },
  ];

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-text-primary mb-4 tracking-tight">联系我们</h1>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">有任何问题或建议？我们随时准备为您提供帮助</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {contacts.map((contact, idx) => (
            <Card key={idx} className="border-0 shadow-card rounded-card bg-white hover:shadow-hover transition-all">
              <CardContent className="p-8">
                <div className="w-14 h-14 rounded-2xl bg-bg-secondary flex items-center justify-center mb-4">
                  <contact.icon className="w-7 h-7 text-primary" />
                </div>
                <h3 className="font-semibold text-text-primary mb-2 text-lg">{contact.title}</h3>
                <p className="text-primary font-medium mb-1">{contact.desc}</p>
                <p className="text-sm text-text-secondary">{contact.detail}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <Card className="border-0 shadow-card rounded-card bg-bg-secondary mt-12">
          <CardContent className="p-10 text-center">
            <h3 className="text-xl font-bold text-text-primary mb-3">商务合作</h3>
            <p className="text-text-secondary leading-relaxed">
              如果您是景区、酒店、旅行社等合作伙伴，<br />
              欢迎联系我们探讨合作机会：<span className="text-primary">business@cattravellog.com</span>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Contact;
